import { NgForOf, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CandidateOptionsService } from '../data-cleaner/candidate-options/candidate-options.service';
import { LoadingComponent } from '../loading/loading.component';
import { IBullhornUser, IDynamoUser } from '../shared/interfaces/user';
import { MessageNotificationService } from '../shared/services/message-notification.service';
import { UsersManagementService } from './users-management.service';

@Component({
  selector: 'app-users-management',
  imports: [
    NgIf,
    NgForOf,
    FormsModule,
    LoadingComponent
  ],
  templateUrl: './users-management.component.html'
})
export class UsersManagementComponent implements OnInit {

  users: IBullhornUser[];
  bullhornUsers: IBullhornUser[];
  selectedUser: number;
  userServicesSubscription: Subscription;
  usersLoaded = false;

  constructor(private usersService: UsersManagementService,
              private candidateOptionsService: CandidateOptionsService,
              private messageNotificationService: MessageNotificationService) {
  }

  ngOnInit() {
    this.getAllUsers();

    this.userServicesSubscription = this.usersService.refreshUsers$.subscribe(() => {
      this.getAllUsers();
    });
  }

  getAllUsers() {
    this.candidateOptionsService.getUsers()
      .subscribe(
        (resp: any) => {
          console.log(resp);
          this.bullhornUsers = [...resp['users']];
          this.usersService.getUsersByCorporation()
            .subscribe((users: IDynamoUser[]) => {
              this.users = this.bullhornUsers.filter(
                bullhornUser => {
                  const corpUser = users.find(dynamoUser => dynamoUser.userId === bullhornUser.id);
                  if (corpUser) {
                    bullhornUser.admin = corpUser.admin;
                    return true;
                  }
                  return false;
                }
              );
              this.bullhornUsers = this.bullhornUsers.filter(
                bullhornUser => !users.find(dynamnoUser => dynamnoUser.userId === bullhornUser.id)
              );
              this.bullhornUsers = this.bullhornUsers.sort((a, b) => {
                if (a.name > b.name) return 1;
                if (a.name < b.name) return -1;
                return 0;
              });
              this.usersLoaded = true;
            });
        });
  }

  deleteUserInDynamo(userId: number): void {
    this.usersService.deleteUserInDynamo(userId)
      .subscribe((updateResponse) => {
        console.log({updateResponse});
        this.messageNotificationService.success('User removed');
      }, (updateError) => {
        console.error({updatedError: updateError});
        this.messageNotificationService.error('User could not be removed', updateError);
      });
  }

  addUserInDynamo(user: any): void {
    this.usersService.insertUserInDynamo(user)
      .subscribe((updateResponse) => {
        console.log({updateResponse});
        this.selectedUser = null;
        this.messageNotificationService.success('User added');
      }, (updateError) => {
        console.log(updateError);
        this.messageNotificationService.error('User could not be added', updateError);
      });
  }
}
